<template>
    <span
        v-for="(partIndex, key) in notePartsCount"
        :key="partIndex"
        class="text-with-line-breaks"
    >
        <template v-if="isPartALink(key)">
            <a
                :href="noteParts.links[key]"
                target="_blank"
            >{{ noteParts.links[key] + ' ' }}</a>
        </template>
        <template v-else>
            {{ noteParts.texts[key] + ' ' }}
        </template>
    </span>
</template>

<script>
export default {
    name: 'NoteContent',
    props: {
        noteParts: {
            type: Object,
            default: () => { return {} }
        }
    },
    computed: {
        notePartsCount () {
            return Object.keys(this.noteParts.texts).length + Object.keys(this.noteParts.links).length
        }
    },
    methods: {
        isPartALink (index) {
            return typeof this.noteParts.links[index] !== 'undefined'
        }
    }
}
</script>

<style scoped>
.text-with-line-breaks {
    white-space: pre-line;
}
</style>
